import { QueryKey } from '@/configs/queryKeys';
import {
	ApiPaginatedResponse,
	ApiQueryOptions,
	Attachment,
	CustomFilters,
	Translations,
} from '@/types/types';
import { QueryFunctionContext } from '@tanstack/react-query';
import { omitBy, trim } from 'lodash';
import EntityApi, { BaseEntity } from './EntityApi';
import httpClient from './httpClient';

export enum ContentType {
	TEXT,
	IMAGE,
	ELEMENT,
}

export interface Content extends BaseEntity {
	slug: string;
	type: ContentType;
	content: string;
	image: Pick<Attachment, 'id' | 'path'>;
	translations: Translations<{
		content: string;
		image: Pick<Attachment, 'id' | 'path'>;
	}>;
}
class ContentApi extends EntityApi<Content> {
	constructor() {
		super(QueryKey.content);
	}

	override async getAll({
		queryKey,
	}: QueryFunctionContext<
		[
			QueryKey,
			Partial<Pick<ApiQueryOptions<Content>, 'search' | 'sortBy'>>?,
			CustomFilters?,
		]
	>) {
		const params = omitBy(
			{
				search: trim(queryKey[1]?.search),
				sortBy: Object.values(queryKey[1]?.sortBy || {}).join(':'),
				limit: -1,
				...queryKey[2],
			},
			(value) => value === ''
		);

		const response = await httpClient.get<ApiPaginatedResponse<Content>>(
			queryKey[0],
			{
				params,
				baseURL: 'https://api.rtwork-esd.com/',
			}
		);

		return response.data.data;
	}
}

export default new ContentApi();
